import axios from 'axios';

const updateUserUri = 'api/user/{id}';
const updateStatePrivacyUri ='api/user/{id}/stateprivacy';
const updateLimitUseOfPIUri ='api/user/{id}/limituseofpi';

export class UserProvider {
    static async updateUser(user) {
        try {
            return await axios.put(updateUserUri.replace('{id}', user.DeviceId), user);
        } catch (error) {
            console.log('Error trying to update user.', error);
        }
    }

    static async updateStatePrivacy(appInstanceId, IsOptedOut) {
        return await axios.put(updateStatePrivacyUri.replace('{id}', appInstanceId), { enabled: IsOptedOut });
    }

    static async updateLimitUseOfPI(appInstanceId, IsOptedOut) {
        return await axios.put(updateLimitUseOfPIUri.replace('{id}', appInstanceId), { enabled: IsOptedOut });
    }
    
    static async saveGPCSignalToStorage(appInstanceId, gpcSignal) {
        return await axios.post('api/users/gpc', { appInstanceId, gpcSignal });
    }
}
